<nz-list class="sidemenuOptnsWthoutScroll">
  @for (p of menulst; track p) {
  <div>
    @if (p.prnt_mnu_itm_id == 0) {
    <nz-list-item class="menu_item">
      <h6>{{ p.mnu_itm_nm }}</h6>
    </nz-list-item>
    } @if (p.prnt_mnu_itm_id != 0) {
    <div class="parent_menu_item">
      @if (p.prnt_mnu_itm_nm != 'MY TICKETS') {
      <div>
        <h6 class="ticket-sidemenu-prnt-item">{{ p.prnt_mnu_itm_nm }}</h6>
      </div>
      } @if (p.prnt_mnu_itm_nm == 'MY TICKETS') {
      <div>
        <h6 class="ticket-sidemenu-prnt-item">{{ p.prnt_mnu_itm_nm }}</h6>
      </div>
      } @for (a of p.sub_mnus; track a) {
      <nz-list-item class="child_menu_item">
        <h6 (click)="item(a.mnu_itm_nm)">
          <nz-icon
            class="ticket-sidemenu-icon-style"
            [ngStyle]="{
              'background-color': a.mnu_icn_tx_bg,
              color: a.mnu_icn_tx_clr
            }"
            >{{ a.mnu_icn_tx }}</nz-icon
          >
          {{ a.mnu_itm_nm }}
        </h6>
      </nz-list-item>
      }
    </div>
    }
  </div>
  }
</nz-list>
